// Shared per-tab feature-key sets — single source of truth for the strip-hidden
// gate (SidebarSwitches) and the panel-disable gate (DataLabPanel / MappingPanel),
// so the two stay in sync instead of re-listing the keys per call site.
export const DATA_LAB_FEATURES = [
  'data_lab_vq',
  'data_lab_cf',
  'data_lab_xpert',
  'data_lab_concept',
  'data_lab_storytelling'
]
export const MAPPING_FEATURES = ['data_lab_concept', 'data_lab_tracker']
// Publish-side counterparts of MAPPING_FEATURES — a Mapping type is usable only when both
// its editor-side feature and its publish-side feature are enabled.
export const MAPPING_PUBLISH_FEATURES = ['data_lab_concept_publish', 'data_lab_tracker_publish']
